import * as Sentry from '@sentry/react'
import { beforeSend, beforeBreadcrumb } from './index'

const SENTRY_IGNORE_ERRORS = [
  /Request aborted/i,
  /canceled/i,
  /AbortError/i,
  /NotSupportedError/i,
  /Failed to read the '(sessionStorage|localStorage)' property from 'Window'/i,
  /The operation is insecure/i,
  /Unexpected token/,
  /Unexpected end of/i,
  /Unexpected identifier/i,
  /has already been declared/,
  /ResizeObserver loop/i,
  /top\.GLOBALS/,
  /vid_mate_check/i,
  /Script error\.?$/i,
  /Loading (CSS )?chunk/i,
  /ChunkLoadError/i,
  /Importing a module script failed/i,
  /Failed to fetch dynamically imported module/i,
  /Network Error/i,
  /Failed to fetch/i,
  /Load failed/i,
  /timeout exceeded/i,
  /timeout of \d+ms exceeded/i,
  /captured as promise rejection/i,
  /ServiceWorker/i,
  /service worker/i,
  /newestWorker is null/i,
  /window\.webkit\.messageHandlers/i,
  /Object doesn't support property or method/i,
  /fb_xd_fragment/,
  /viewport is not defined/i,
  /Internal error/i,
]
export const initSentry = () =>
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV ?? 'development',
    release: process.env.REACT_APP_VERSION,
    integrations: [
      Sentry.breadcrumbsIntegration({
        xhr: false,
        fetch: false,
        dom: false,
        console: false,
      }),
    ],
    maxBreadcrumbs: 50,
    enabled: process.env.REACT_APP_ENV !== 'development',
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    beforeSend: beforeSend,
    beforeBreadcrumb: beforeBreadcrumb,
  })
